import Route from '@ember/routing/route';

export default class AuthenticatedAdminReportingReportViewerRoute extends Route {}
